import PropTypes from 'prop-types';
import {ImageUploadField} from '@/components/molecules';
import {MediaPreviewWrapper} from '@/components/organisms';
import {
  PEPIRIS_IMAGE_MAX_SIZE_BYTES,
  PEPIRIS_IMAGE_TYPES
} from '@/utils/constants/perfectStoreConstants';
import {pepirisImageSpecText} from './schemas';

const PepIrisImageRow = ({
  label,
  image,
  dimensions,
  previewType,
  previewScale,
  onChange,
  onDelete,
  dataTestId
}) => {
  const previewImage = image?.imageUri || image?.imageUrl || null;

  return (
    <div
      className='mb-4 grid gap-6 rounded-lg border border-[color:var(--color-border-default)] p-4 md:grid-cols-2'
      data-testid={dataTestId}>
      <div>
        <p className='mb-3 text-sm font-bold'>{label}</p>
        <ImageUploadField
          label='Upload'
          description={pepirisImageSpecText(dimensions)}
          acceptedTypes={PEPIRIS_IMAGE_TYPES}
          dimensions={dimensions}
          aspectRatio={dimensions.width / dimensions.height}
          aspectRatioLabel={`${dimensions.width} x ${dimensions.height}`}
          maxSizeBytes={PEPIRIS_IMAGE_MAX_SIZE_BYTES}
          imageUri={previewImage || ''}
          onChange={onChange}
          onDelete={onDelete}
          dataTestId={`${dataTestId}-upload`}
          containerClassName='w-full rounded-lg border border-[color:var(--color-border-default)] p-3'
        />
      </div>
      <div>
        <p className='mb-3 text-sm font-bold'>Image Preview in App</p>
        <MediaPreviewWrapper
          types={[previewType]}
          content={[{image: previewImage}]}
          scale={previewScale}
        />
      </div>
    </div>
  );
};

PepIrisImageRow.propTypes = {
  label: PropTypes.string.isRequired,
  image: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageUri: PropTypes.string,
    fileName: PropTypes.string
  }),
  dimensions: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired,
  previewType: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  previewScale: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  dataTestId: PropTypes.string.isRequired
};

export default PepIrisImageRow;
